// @owners { team: patients-team }
import { reduxStorage } from './reduxStorage';
import { Storage as MMKVStorage } from './storage';

// purging storage requires getAllKeys to be defined but defining this in reduxStorage
// causes issues with redux-persist and will cause app to crash
export const purgeStorage = {
  ...reduxStorage,
  getAllKeys: <Result = string[]>(): Promise<Result> => {
    const rawKeys = MMKVStorage.getAllKeys();
    // Remove backslashes from keys
    const cleanedKeys = rawKeys.map((key) => key.replace(/\\/g, ''));
    return Promise.resolve(cleanedKeys as unknown as Result);
  },
};
